import { AccessGuids, AlertClassColour, ConfigSystemParams, DgColumnDataType, DgColumnWidths, GridViewTitles, msSize, ToastShowDelay, _MustMatchServerStrings } from 'src/app/core/consts';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, firstValueFrom, throwError } from 'rxjs';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { GridViewService } from 'src/app/core/services/utelize/general/grid-view.service';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { eWebhookLogTriggerSource } from 'src/app/core/enums';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { LocationWebhookConfigDTOe, LocationWebhookConfigDTOe_EmptyObject } from 'src/app/core/models/system/location-webhook/location-webhook-config.dto';
import { LocationWebhookConfigService } from 'src/app/core/services/utelize/system/location-webhook/location-webhook-config-service';
import { LocationWebhookFieldDTOe } from 'src/app/core/models/system/location-webhook/location-webhook-field.dto';
import { LocationWebhookTestResultDTO } from 'src/app/core/models/system/location-webhook/location-webhook-test-result.dto';
import { ModalForceCloseService } from 'src/app/core/services/utelize/general/modal-force-close-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PageCompHeaderComponent } from "src/app/core/page-components/page-comp-header/page-comp-header.component";
import { Subscription } from 'rxjs';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { ToastService } from 'src/app/core/services/toast-service';
import { WebhookLogDTO } from 'src/app/core/models/system/webhook/webhook-log.dto';
import { WebhookLogService } from 'src/app/core/services/utelize/system/webhook/webhook-log-service';

const exportFilenameSuffix="WebhookLog";
const mainTitle           =GridViewTitles.webhookLog;
const popUpTitle          =GridViewTitles.webhookLog;

@Component({
  selector: 'app-location-webhook-modal-form',
  templateUrl: './location-webhook-modal-form.component.html',
  styleUrls: ['./location-webhook-modal-form.component.scss'],
  providers: [GridViewService]
})

export class LocationWebhookModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() initialCompanyId: number | undefined;

  @Output() locationWebhookFormCancelled   : EventEmitter<void>=new EventEmitter<void>();
  @Output() locationWebhookDataHasBeenSaved: EventEmitter<void>=new EventEmitter<void>();

  @ViewChild('completedModalForm',              { static: false }) completedModalForm!             : CompletedModalFormComponent;
  @ViewChild('gridViewWebhookLog',              { static: false }) gridViewWebhookLog!             : GridViewComponent;
  @ViewChild('locationWebhookModalFormContent', { static: false }) locationWebhookModalFormContent!: TemplateRef<void>;
  @ViewChild(PageCompHeaderComponent                             ) pageHeader!                     : PageCompHeaderComponent;

  get canSendTest      () { return !this.testInProgress
                                   && !this.hasUnsavedChanges
                                   && ((this.locationWebhookForm?.controls["endpointUrl"]?.value ?? "").trim().length>0); }
  get hasFieldSelection() { return Array.isArray(this.config?.fields)                                                   ; }
  get hasPartnerIdRef  () { return this.config?.partnerIdRef !== undefined                                              ; }
  get hasUnsavedChanges() { return this.locationWebhookForm?.dirty ?? false                                             ; }
  get payloadFields    () { return this.config?.fields ?? []                                                            ; }
  
  get canReplayLastCountryChange() { return this.componentAccessUserService.hasAccessGuid(AccessGuids.FormLocationWebhookReplayLastCountryChange, true); }

  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false)       }

  private activeSub                   : Subscription | undefined;
  private config                      : LocationWebhookConfigDTOe | undefined;
  private curUser                     : SystemUserDTO;
  private gridViewDefaults!           : GridViewDefaults;
  private lastFailureWindowDays       : number=7;
  private locationWebhookModalFormRef!: NgbModalRef;
  private savedMessage                : string="Changes applied.";
  private secretHiddenOnLoad          : boolean=false;

  public activeTab                : number=1;
  public alertColourProgress      : string=AlertClassColour.Grey;
  public companyId                : number=-1;
  public dgActionColumnWebhookLog!: DgActionColumn | undefined;
  public dgApiPathWebhookLog!     : DgApiPath | undefined;
  public dgColumnsWebhookLog!     : Array<DgColumn>;
  public dgPopupWebhookLog!       : DgPopup | undefined;
  public dgPropertiesWebhookLog!  : DgProperties | undefined;
  public endpointUrlMaxLength     : number=2000;
  public formSubmitted            : boolean=false;
  public formTitle                : string="Location Webhook";
  public gotDgProperties          : boolean=false;
  public lastFailure              : WebhookLogDTO | undefined;
  public locationWebhookForm!     : UntypedFormGroup;
  public navItem_Configuration    : number=2;
  public navItem_Webhook          : number=1;
  public optionalFields           : LocationWebhookFieldDTOe[]=[];
  public partnerIdRefMaxLength    : number=100;
  public requiredFields           : LocationWebhookFieldDTOe[]=[];
  public showLog                  : boolean=false;
  public testInProgress           : boolean=false;
  public testResult               : LocationWebhookTestResultDTO | undefined;
  public testWasReplay            : boolean=false;

  constructor(
    private authenticationService       : AuthenticationService,
    private componentAccessUserService  : ComponentAccessUserService,
    private configSystemService         : ConfigSystemService,
    private encryptionService           : EncryptionService,
    private exceptionsService           : ExceptionsService,
    private formBuilder                 : UntypedFormBuilder,
    private lastPassKillerService       : LastPassKillerService,
    private locationWebhookConfigService: LocationWebhookConfigService,
    private modalForceCloseService      : ModalForceCloseService,
    private modalService                : NgbModal,
    private toastService                : ToastService,
    private webhookLogService           : WebhookLogService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
  }

  public ngOnInit(): void {
    try {
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.activeSub?.unsubscribe();
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async openForm(companyId: number): Promise<void> {
    try {
      this.activeTab          =this.navItem_Webhook;
      this.alertColourProgress=AlertClassColour.Grey;
      this.companyId          =companyId;
      this.formSubmitted      =false;
      this.gotDgProperties    =false;
      this.lastFailure        =undefined;
      this.secretHiddenOnLoad =false;
      this.showLog            =false;
      this.testInProgress     =false;
      this.testResult         =undefined;
      this.testWasReplay      =false;
      this.setUpForm();

      await this.getConfigAndOpenModal(companyId);

      await this.setUpDgApiPaths();
      this.setUpDgActionColumn();
      this.setUpDgPopup();
      this.setUpDgProperties();
      this.setUpDgColumns();
      this.loadLastFailure();

      this.gotDgProperties=true;
    }
    catch(e) {
      this.locationWebhookFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async getConfigAndOpenModal(companyId: number): Promise<void> {
    try {
      const data=await firstValueFrom(this.locationWebhookConfigService.getByCompanyId(companyId)
                                      .pipe(
                                        catchError(error => {
                                          throw new Error(this.exceptionsService.formatHttpError(error));
                                        })
                                      ));

      this.config=data ?? LocationWebhookConfigDTOe_EmptyObject();

      this.populateFormFields();
      this.openModal();
    }
    catch(e) {
      this.locationWebhookFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.locationWebhookModalFormRef=this.modalService.open(this.locationWebhookModalFormContent, {
        backdrop     : this.modalBackGround,
        beforeDismiss: () => { return this.modalForceCloseService.isForcing(); },
        centered     : true,
        keyboard     : false,
        size         : msSize.Medium,
      });
    }
    catch(e) {
      this.locationWebhookFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private populateFormFields(): void {
    try {
      if (this.config != undefined) {
        this.secretHiddenOnLoad=this.config.secret==_MustMatchServerStrings.HiddenValue;

        this.locationWebhookForm.controls["active"      ].setValue(this.config.active       ?? false);
        this.locationWebhookForm.controls["endpointUrl" ].setValue(this.config.endpointUrl  ?? ""   );
        this.locationWebhookForm.controls["id"          ].setValue(this.config.id                   );
        this.locationWebhookForm.controls["partnerIdRef"].setValue(this.config.partnerIdRef ?? ""   );
        this.locationWebhookForm.controls["secret"      ].setValue(this.config.secret       ?? ""   );

        if (this.hasFieldSelection) {
          this.config.fields=[...this.payloadFields].sort((a, b) => (a?.sortOrder ?? 0) - (b?.sortOrder ?? 0));

          this.optionalFields=this.orderForTwoColumns(this.payloadFields.filter(f => !f?.mandatory));
          this.requiredFields=this.orderForTwoColumns(this.payloadFields.filter(f =>  f?.mandatory));

          this.addFieldControls();
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private orderForTwoColumns(fields: LocationWebhookFieldDTOe[]): LocationWebhookFieldDTOe[] {
    try {
      const sorted : LocationWebhookFieldDTOe[]=[...fields].sort((a, b) => (a?.displayName ?? "").localeCompare(b?.displayName ?? ""));
      const rows   : number                    =Math.ceil(sorted.length / 2);
      const ordered: LocationWebhookFieldDTOe[]=[];

      for (let i=0; i<rows; i++) {
        ordered.push(sorted[i]);

        if (i + rows<sorted.length)
          ordered.push(sorted[i + rows]);
      }

      return ordered;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return fields;
    }
  }

  //#region locationWebhookForm

  get formData() {
    return this.locationWebhookForm.controls;
  }

  private setUpForm(): void {
    try {
      this.activeSub?.unsubscribe();
      this.removeFormFields(this.locationWebhookForm);
      this.locationWebhookForm=this.formBuilder.group({ });
      this.addFormFields(this.locationWebhookForm);
      this.applyActiveValidators(this.locationWebhookForm.controls["active"].value==true);

      this.activeSub=this.locationWebhookForm.controls["active"].valueChanges.subscribe(value => this.applyActiveValidators(value==true));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyActiveValidators(active: boolean): void {
    try {
      const urlControl=this.locationWebhookForm.controls["endpointUrl"];

      if (active)
        urlControl.setValidators([Validators.required, Validators.maxLength(this.endpointUrlMaxLength), Validators.pattern(/^https:\/\/.+/i)]);
      else
        urlControl.setValidators([Validators.maxLength(this.endpointUrlMaxLength), Validators.pattern(/^https:\/\/.+/i)]);

      urlControl.updateValueAndValidity({ emitEvent: false });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormFields(formGroup: UntypedFormGroup): void {
    try {
      this.addFormControl(formGroup, "active",      "", []);
      this.addFormControl(formGroup, "endpointUrl", "", [Validators.maxLength(this.endpointUrlMaxLength), Validators.pattern(/^https:\/\/.+/i)]);
      this.addFormControl(formGroup, "id",          "", []);
      this.addFormControl(formGroup, "partnerIdRef","", [Validators.maxLength(this.partnerIdRefMaxLength)]);
      this.addFormControl(formGroup, "secret",      "", []);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFieldControls(): void {
    try {
      const fieldsGroup: UntypedFormGroup=this.formBuilder.group({ });

      for (const field of this.payloadFields) {
        const control=new FormControl(field.mandatory ? true : (field.selected ?? true));

        if (field.mandatory)
          control.disable({ emitEvent: false });

        fieldsGroup.addControl(field.fieldKey, control);
      }

      this.locationWebhookForm.setControl("fields", fieldsGroup, { emitEvent: false });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : string,
                         validators: Validators): void {
    try {
      form.addControl(dataField, new FormControl(value, validators));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private removeFormFields(form: UntypedFormGroup): void {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public locationWebhookFormCancel(): void {
    try {
      this.locationWebhookFormCancelled.emit();
      this.locationWebhookModalFormRef?.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region delivery log

  private async setUpDgApiPaths(): Promise<void> {
    try {
      const encResult     =await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>this.companyId, true));
      const companyIdEncSS=encResult.result;

      const basePath=environment.eSimApi + eSimApiPaths.WebhookLog;
      const url     =basePath + "/" + eSimApiPaths.WebhookLogForCompany + "/" + companyIdEncSS;

      if (this.dgApiPathWebhookLog==undefined)
        this.dgApiPathWebhookLog=this.gridViewDefaults.setUpDgApiPaths(basePath);

      this.dgApiPathWebhookLog!.get=url;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumn(): void {
    try {
      this.dgActionColumnWebhookLog               =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumnWebhookLog!.allowDeleting=false;
      this.dgActionColumnWebhookLog!.allowUpdating=false;
      this.dgActionColumnWebhookLog!.visible      =false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopup(): void {
    try {
      this.dgPopupWebhookLog=this.gridViewDefaults.setUpDgPopup(popUpTitle);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgProperties(): void {
    try {
      this.dgPropertiesWebhookLog=this.gridViewDefaults.setUpDgProperties(mainTitle, exportFilenameSuffix);

      this.dgPropertiesWebhookLog!.gridKey          ="LocationWebhookLog";
      this.dgPropertiesWebhookLog!.height           =320;
      this.dgPropertiesWebhookLog!.pageSize         =10;
      this.dgPropertiesWebhookLog!.remoteOperations =false;
      this.dgPropertiesWebhookLog!.showAddButton    =false;
      this.dgPropertiesWebhookLog!.showRefreshButton=true;
      this.dgPropertiesWebhookLog!.skipStickyLayout =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumns(): void {
    try {
      let dgColumn: DgColumn | undefined;

      //ID
      dgColumn                 =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumn!.formVisible    =false;
      dgColumn!.gridVisible    =false;
      dgColumn!.width          =DgColumnWidths.id;
      this.dgColumnsWebhookLog =[dgColumn!];

      //Timestamp
      dgColumn                 =this.gridViewDefaults.setUpDgColumn("timestamp", "Fired", "", DgColumnDataType.datetime);
      dgColumn!.readOnly       =true;
      this.dgColumnsWebhookLog.push(dgColumn!);

      //TriggerSource
      dgColumn                      =this.gridViewDefaults.setUpDgColumn("triggerSource", "Trigger", 0, DgColumnDataType.number);
      dgColumn!.alignment           ="left";
      dgColumn!.calculateDisplayValue=(rowData: any) => this.triggerSourceName(rowData?.triggerSource);
      dgColumn!.readOnly            =true;
      dgColumn!.width               =100;
      this.dgColumnsWebhookLog.push(dgColumn!);

      //Success
      dgColumn                 =this.gridViewDefaults.setUpDgColumn("success", "OK", false, DgColumnDataType.boolean);
      dgColumn!.readOnly       =true;
      dgColumn!.width          =70;
      this.dgColumnsWebhookLog.push(dgColumn!);

      //HttpStatusCode
      dgColumn                 =this.gridViewDefaults.setUpDgColumn("httpStatusCode", "Status", 0, DgColumnDataType.number);
      dgColumn!.readOnly       =true;
      dgColumn!.width          =90;
      this.dgColumnsWebhookLog.push(dgColumn!);

      //ElapsedMs
      dgColumn                 =this.gridViewDefaults.setUpDgColumn("elapsedMs", "ms", 0, DgColumnDataType.number);
      dgColumn!.readOnly       =true;
      dgColumn!.width          =80;
      this.dgColumnsWebhookLog.push(dgColumn!);

      //AttemptNumber
      dgColumn                 =this.gridViewDefaults.setUpDgColumn("attemptNumber", "Attempt", 0, DgColumnDataType.number);
      dgColumn!.readOnly       =true;
      dgColumn!.width          =90;
      this.dgColumnsWebhookLog.push(dgColumn!);

      //Iccid
      dgColumn                 =this.gridViewDefaults.setUpDgColumn("iccid", "ICCID", "", DgColumnDataType.string);
      dgColumn!.readOnly       =true;
      dgColumn!.width          =172;
      this.dgColumnsWebhookLog.push(dgColumn!);

      //CompanyName
      dgColumn                 =this.gridViewDefaults.setUpDgColumn("companyName", "Company", "", DgColumnDataType.string);
      dgColumn!.readOnly       =true;
      this.dgColumnsWebhookLog.push(dgColumn!);

      //ErrorMessage
      dgColumn                 =this.gridViewDefaults.setUpDgColumn("errorMessage", "Error", "", DgColumnDataType.string);
      dgColumn!.readOnly       =true;
      this.dgColumnsWebhookLog.push(dgColumn!);

      //EndpointUrl
      dgColumn                 =this.gridViewDefaults.setUpDgColumn("endpointUrl", "Endpoint", "", DgColumnDataType.string);
      dgColumn!.gridVisible    =false;
      dgColumn!.readOnly       =true;
      this.dgColumnsWebhookLog.push(dgColumn!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private loadLastFailure(): void {
    try {
      this.webhookLogService.getForCompany(this.companyId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        })
      )
      .subscribe({
        next : (rows: WebhookLogDTO[]) => {
          const liveRows=(rows ?? [])
                         .filter(row => row?.triggerSource==eWebhookLogTriggerSource.Live)
                         .sort((a, b) => new Date(b?.timestamp ?? 0).getTime() - new Date(a?.timestamp ?? 0).getTime());

          const latest=liveRows[0];

          this.lastFailure=(latest?.success==false && this.isWithinLastFailureWindow(latest?.timestamp)) ? latest : undefined;
        },
        error: error => { this.exceptionsService.handleException(new Error(error)); }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private isWithinLastFailureWindow(timestamp: Date | null | undefined): boolean {
    try {
      if (timestamp==undefined)
        return false;

      const ageInDays=(new Date().getTime() - new Date(timestamp).getTime()) / (1000 * 60 * 60 * 24);

      return ageInDays<=this.lastFailureWindowDays;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private triggerSourceName(triggerSource: number | null | undefined): string {
    try {
      return triggerSource==undefined
             ? ""
             : (eWebhookLogTriggerSource[triggerSource] ?? triggerSource.toString());
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public toggleShowLog(): void {
    try {
      this.showLog=!this.showLog;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region test send/replay

  public copyPayloadSent(): void {
    try {
      const payload: string=this.testResult?.payloadSent ?? "";

      if (payload.length==0)
        return;

      navigator.clipboard?.writeText(payload)
                          .then (() => {
                            this.toastService.show("Payload copied to clipboard", { classname: 'bg-success text-white', delay: ToastShowDelay.Success });
                          })
                          .catch(() => {
                            this.toastService.show("Unable to copy to clipboard",  { classname: 'bg-danger text-white',  delay: ToastShowDelay.Danger  });
                          });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public replayLastCountryChange(): void {
    try {
      this.runWebhookProbe(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public sendTest(): void {
    try {
      this.runWebhookProbe(false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private runWebhookProbe(isReplay: boolean): void {
    try {
      this.testInProgress=true;
      this.testResult    =undefined;
      this.testWasReplay =isReplay;

      const request=isReplay ? this.locationWebhookConfigService.replayLastCountryChange(this.companyId)
                             : this.locationWebhookConfigService.testSend(this.companyId);

      request
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        })
      )
      .subscribe({
        next : (result: LocationWebhookTestResultDTO) => {
          this.testInProgress=false;
          this.testResult    =result;

          this.loadLastFailure();

          if (this.showLog)
            this.gridViewWebhookLog?.refreshData(true);
        },
        error: error => {
          this.testInProgress=false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.testInProgress=false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public locationWebhookCompletedModalHasBeenClosed(): void {
    try {
      this.locationWebhookModalFormRef?.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public locationWebhookFormSubmitAttempt(): void {
    try {
      this.formSubmitted=true;

      if (this.locationWebhookForm.valid) {
        this.prepareToSave();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private prepareToSave(): void {
    try {
      if (this.config != undefined) {
        const secretValue: string=this.locationWebhookForm.controls["secret"].value ?? "";

        this.config.active     =this.locationWebhookForm.controls["active"].value ?? false;
        this.config.companyID  =this.companyId;
        this.config.endpointUrl=this.locationWebhookForm.controls["endpointUrl"].value;
        this.config.id         =this.locationWebhookForm.controls["id"].value;

        this.config.secret=(this.secretHiddenOnLoad && secretValue==_MustMatchServerStrings.HiddenValue) ? _MustMatchServerStrings.HiddenValue : secretValue;

        if (this.hasPartnerIdRef) {
          const partnerIdRef: string=(this.locationWebhookForm.controls["partnerIdRef"].value ?? "").trim();
          
          this.config.partnerIdRef=partnerIdRef.length > 0 ? partnerIdRef : null;
        }

        if (this.hasFieldSelection) {
          const fieldsGroup=<UntypedFormGroup>this.locationWebhookForm.controls["fields"];

          this.config.fields=this.payloadFields.map(field => ({
            ...field,
            selected: field.mandatory ? true : (fieldsGroup?.controls[field.fieldKey]?.value==true)
          }));
        }

        this.saveConfig();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveConfig(): void {
    try {
      this.locationWebhookConfigService.save(this.companyId, <LocationWebhookConfigDTOe>this.config)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        })
      )
      .subscribe({
        next : () => {
          this.alertColourProgress=AlertClassColour.Green;
          
          this.locationWebhookForm.markAsPristine();
          this.locationWebhookDataHasBeenSaved.emit();
          this.saveProcessComplete();
        },
        error: error => {
          this.alertColourProgress=AlertClassColour.Red;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveProcessComplete(): void {
    try {
      this.completedModalForm.openForm(this.savedMessage, "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public completedModalHasBeenClosed(): void {
    try {
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
